<mat-card class="cardWithShadow">
  <mat-card-content>
    <div class="demo-main">
      <!--<div class="header">
        <div>Opened directoy name: {{ openedDir$ | async }}</div>
        <div>Selection length: {{ selectionLength$ | async }}</div>
        <div>Root children length: {{ rootLen$ | async }}</div>
      </div>-->
      <div class="demo-container">
        <div class="inner">

          <nxe-explorer [showSwitcher]="true" [showEditFile]="true"></nxe-explorer>
          <!--<nxe-breadcrumbs></nxe-breadcrumbs>-->
          <!--<nxe-content></nxe-content>-->
          <!--<nxe-icons></nxe-icons>-->
          <!--<nxe-list></nxe-list>-->
          <!-- <nxe-tree></nxe-tree>-->
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
